import callAccountsApi from '../data-provider'

if (!callAccountsApi) {
  callAccountsApi = require('../data-provider').callAccountsApi
}

const importStarling = async (account, sourceAccount, data) => {
  console.log("Importing Starling", account)

  let rows = data.split("\n")

  console.log("cols", rows[0].split(','))


  const starlingTypes = await callAccountsApi("transactions", "getStarlingTransactionTypes")

  const results = rows.reverse().map(r => processRow(account, sourceAccount, starlingTypes, r.split(',')))

  return results
}

const processRow = async (account, sourceAccount, starlingTypes, row) => {

  console.log("processRow...", row)

  const transaction_type_id = starlingTypes[row[2]]

  let transaction = {
    account_id: account.account_id,
    transaction_date: row[0],
    transaction_type_id,
    notes: row[1]
  }

  let amount = parseFloat(row[3], 10)

  if (amount > 0) {
    transaction.amount_in = amount
  }
  else {
    transaction.amount_out = amount * -1 // Turn negative money to positive
  }

  let result = await callAccountsApi("transactions", "insertTransaction", { transaction })

  return result
}

export default importStarling